import React from 'react';

const config = {
  clean: {
    label: 'Clean',
    badgeClass: 'bg-primary-100 text-primary-700',
    dotClass: 'bg-primary-500',
  },
  caution: {
    label: 'Caution',
    badgeClass: 'bg-warning/10 text-warning',
    dotClass: 'bg-warning',
  },
  avoid: {
    label: 'Avoid',
    badgeClass: 'bg-error/10 text-error',
    dotClass: 'bg-error',
  },
};

function SafetyBadge({ rating, size = 'md' }) {
  const { label, badgeClass, dotClass } = config[rating] ?? config.caution;

  const sizeClass = size === 'sm'
    ? 'px-2 py-0.5 text-caption'
    : 'px-3 py-1 text-small';

  return (
    <span
      className={`inline-flex items-center gap-1.5 flex-shrink-0 rounded-sm font-semibold whitespace-nowrap ${sizeClass} ${badgeClass}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotClass}`} aria-hidden="true" />
      {label}
    </span>
  );
}

export default SafetyBadge;
